var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useCallback, useMemo } from "react";
var useAssociateProduct = function () {
    var listProjects = useCallback(function (responseProject) {
        var drawerProjectList = responseProject.map(function (item) { return ({
            id: item.id,
            name: item.description || "",
        }); });
        var ProjectList = drawerProjectList.map(function (item) { return (__assign(__assign({}, item), { value: item.id, active: false })); });
        return { drawerProjectList: drawerProjectList, ProjectList: ProjectList };
    }, []);
    return useMemo(function () { return ({ listProjects: listProjects }); }, [listProjects]);
};
export default useAssociateProduct;
